<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <!-- 卡片顯示樣式 -->
    <div v-if="personList.length > 0" class="tool-list">
      <span style="margin-right: 15px">
        <strong>本次搜尋筆數：{{ totalPerson }} 筆</strong>
      </span>
      <button type="button" class="btn btn-info mr-2" @click="exportTalent">
        匯出
      </button>
      <div class="tool-list-about-card">
        <span
          @click="gridStyle = 'block'"
          :class="{ active: gridStyle == 'block' }"
        >
          <eva-icon fill="#000" name="grid-outline" />
        </span>
        <span
          @click="gridStyle = 'list'"
          :class="{ active: gridStyle == 'list' }"
        >
          <eva-icon fill="#000" name="list-outline" />
        </span>
      </div>
    </div>

    <div
      v-if="doSearch && personList.length === 0"
      style="text-align: center; padding-top: 100px"
    >
      <img
        style="
          width: 250px;
          opacity: 0.5;
          background-color: #eaeaea;
          border-radius: 50%;
          margin-bottom: 20px;
        "
        src="@/assets/img/no_record.png"
        alt=""
      /><br />
      查無資料
    </div>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard
          ref="personCard"
          :showCheckbox="true"
          :person="person"
          @updatePersonList="updatePersonList"
        >
          <template v-slot:middleContent="{ props }">
            <ul style="height: 300px; font-size: 15px; line-height: 26px">
              <li class="mt-1">學歷</li>
              <span v-html="props.Education[0]"></span>
              <span v-html="props.Education[1]"></span>
              <li class="mt-1">工作經歷／總年資{{ props.TotalSeniority }}年</li>
              <span v-html="props.WorkExperience[0]"></span>
              <span v-html="props.WorkExperience[1]"></span>
              <li>履歷來源 {{ props.ResumeSource }}</li>
              <li class="mt-1">
                最後更新時間 {{ $common.dateTimeFormatter(props.UpdateTime) }}
              </li>
              <li class="mt-1">
                最新應徵職缺 {{ props.LatestJobApply }}／{{
                  props.LatestStatus
                }}
              </li>
            </ul>
          </template>

          <template v-slot:buttonGroup="{ props }">
            <el-dropdown>
              <button type="button" class="el-dropdown-link">
                檢視資訊<i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showDetailModal(props)">
                  檢視履歷
                </el-dropdown-item>
                <el-dropdown-item @click.native="showProgressRecord(props)">
                  檢視歷程
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <button type="button" @click="showContactInfo(props)">
              聯繫資訊
            </button>
            <button type="button" @click="showJobIntention(props)">
              職缺意願
            </button>
            <button
              v-if="props.BlacklistEver"
              type="button"
              @click="showBlackHistory(props)"
            >
              黑名單歷程
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 分頁 -->
    <el-pagination
      v-if="personList.length > 0"
      background
      layout="prev, pager, next, jumper"
      :total="totalPerson"
      :page-size="9"
      @current-change="changePage"
      @size-change="changePage"
    >
    </el-pagination>

    <!-- 功能列 -->
    <ActionBar
      :show="showActionBar"
      :totalPerson="totalPerson"
      :selectedCardList="choosePersonList"
      @showActionBar="showActionBar = !showActionBar"
      @selectAllCards="selectAllCards"
      @clearSelectCard="clearSelectCard"
    >
      <template v-slot:button>
        <button
          type="button"
          class="action-btn"
          @click="
            openActionModal({ action: 'matchJob' }), (showActionBar = false)
          "
        >
          <eva-icon name="brush-outline" fill="#FFF" />
          <span>轉入職缺</span>
        </button>
        <button
          type="button"
          class="action-btn"
          @click="
            openActionModal({ action: 'shareResume' }), (showActionBar = false)
          "
        >
          <eva-icon name="paper-plane-outline" fill="#FFF" />
          <span>分享履歷</span>
        </button>
        <button
          type="button"
          class="action-btn"
          style="background: red"
          @click="
            openActionModal({ action: 'addBacklist' }), (showActionBar = false)
          "
        >
          <eva-icon name="minus-outline" fill="#FFF" />
          <span>加入黑名單</span>
        </button>
        <button
          type="button"
          class="action-btn"
          style="background: green"
          @click="blacklistRemoval"
        >
          <eva-icon name="undo-outline" fill="#FFF" />
          <span>解除黑名單</span>
        </button>
      </template>
    </ActionBar>

    <!-- 分享履歷 Modal -->
    <div
      id="shareResumeModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver v-slot="{ handleSubmit }">
            <div class="modal-header">
              <span>分享履歷</span>
            </div>
            <div class="modal-body">
              <label for="">收件者：</label>
              <ValidationProvider
                ref="ReceiverIds"
                v-slot="{ errors }"
                rules="required"
              >
                <v-select
                  :options="supervisorOptions"
                  multiple
                  label="Name"
                  placeholder="請選擇"
                  :reduce="(ReceiverIds) => ReceiverIds.Guid"
                  v-model="ReceiverIds"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.Name }}
                  </template>
                </v-select>
                <p v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
              <img
                class="job-position"
                src="@/assets/img/job_position.png"
                alt=""
              />
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                @click="showActionBar = true"
              >
                取消
              </button>
              <button
                type="submit"
                class="btn btn-success"
                @click="handleSubmit(shareResume)"
              >
                確定
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- 轉入職缺 Modal -->
    <div
      id="matchJobModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(matchJobManagement)">
              <div class="modal-header">
                <span>轉入職缺</span>
              </div>
              <div class="modal-body">
                <label for="">選擇職缺：</label>
                <ValidationProvider
                  ref="matchDemandId"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <el-select
                    class="w-100"
                    :filterable="true"
                    value-key="ManpowerDemandNo"
                    placeholder="請選擇"
                    v-model="matchDemandId"
                  >
                    <el-option
                      style="width: 760px"
                      v-for="opening in openingOptions"
                      :key="opening.ManpowerDemandNo"
                      :label="`${opening.ManpowerDemandNo}-${opening.ManpowerDemandName}`"
                      :value="opening.ManpowerDemandNo"
                    >
                    </el-option>
                  </el-select>
                  <p v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
                <img
                  class="job-position"
                  src="@/assets/img/job_position.png"
                  alt=""
                />
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="showActionBar = true"
                >
                  取消
                </button>
                <button type="submit" class="btn btn-success">確定</button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- 加入黑名單 Modal -->
    <div
      id="blacklistModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver v-slot="{ handleSubmit }">
            <div class="modal-header">
              <span>加入黑名單</span>
            </div>
            <div class="modal-body">
              <div class="form-group form">
                <label for="">
                  <span style="color: #ff0000">*</span>
                  請輸入原因
                </label>
                <ValidationProvider
                  ref="backlistReason"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <textarea
                    type="text"
                    class="form-control"
                    rows="5"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model="backlistReason"
                  />
                  <span
                    v-if="errors[0] && !is_composing"
                    class="text-danger ml-1"
                  >
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                @click="showActionBar = true"
              >
                取消
              </button>
              <button
                type="button"
                class="btn btn-danger"
                @click="handleSubmit(addBlacklist)"
              >
                加入
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- 黑名單歷程 Modal -->
    <div
      id="blackHistoryModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <span>黑名單歷程</span>
          </div>
          <div class="modal-body">
            <el-table :data="blackHistoryData" style="width: 100%">
              <el-table-column prop="Status" label="狀態"> </el-table-column>
              <el-table-column prop="Reason" label="黑名單原因">
              </el-table-column>
              <el-table-column
                prop="CreateTime"
                :formatter="dateFormatter"
                label="建立時間"
              >
              </el-table-column>
              <el-table-column prop="CreateUser" label="建立者">
              </el-table-column>
            </el-table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="(detailCurrentPage = 0), (ResumeType = 'IDL')">
              <span>
                <eva-icon name="person-outline" fill="#FFF" />
                IDL 履歷
              </span>
            </a>
            <a @click.prevent="(detailCurrentPage = 0), (ResumeType = 'DL')">
              <span>
                <eva-icon name="person-outline" fill="#FFF" />
                DL 履歷
              </span>
            </a>
            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              />
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <div class="item">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        style="margin-right: 10px"
                        @click="$store.commit('OpenResumeCategoryModal', true)"
                      >
                        分類
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        style="margin-right: 10px"
                        @click="$common.downloadSummaryPDF(ResumeId)"
                      >
                        簡歷
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <!-- 履歷分類  -->
    <ResumeTagModal :ResumeId="ResumeId" />

    <!-- 聯絡資訊  -->
    <ContactInfoModal :personData="interviewee" />

    <!-- API 回應訊息 -->
    <ResponseDataModal
      :successfulList="successMessage"
      :failedList="failMessage"
    >
      <template v-if="messageType === 'job'" v-slot:header>
        <button
          type="button"
          style="margin-top: 10px; margin-left: 10px; margin-bottom: -10px"
          class="btn btn-outline-danger btn-sm"
          @click="goToJobListPage"
        >
          點此進入職缺
        </button>
      </template>
    </ResponseDataModal>

    <!-- 職缺意願 -->
    <JobIntentionModal :personData="interviewee" />

    <!-- 檢視歷程 -->
    <ProgressRecordModal :Name="Name" :UserId="UserId" :Email="Email" />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 職缺意願
import JobIntentionModal from "@/components/back/Modal/JobIntentionMail";
// 聯繫資訊
import ContactInfoModal from "@/components/back/Modal/ContactInfo";
// 履歷分類
import ResumeTagModal from "@/components/back/Modal/ResumeTag";
// 歷程
import ProgressRecordModal from "@/views/back/TalentQuery/ResultPage/Modal/ProgressRecord";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 功能列
import ActionBar from "@/components/back/ToolBar/ActionBar";
// API 回應訊息
import ResponseDataModal from "@/components/back/Modal/ResponseData";

export default {
  name: "QueryResult",

  components: {
    PersonCard,
    JobIntentionModal,
    ContactInfoModal,
    ResumeTagModal,
    ProgressRecordModal,
    IdlResume,
    DlResume,
    ActionBar,
    ResponseDataModal,
  },
  data() {
    return {
      is_composing: false,

      // 卡片顯示樣式
      gridStyle: "block",

      // 從哪個頁面進來
      originPath: "",

      // 停止call API（停止取得下一頁）
      stopGetNextPage: false,

      // 人員資料
      currentPage: 1, // 當前頁數
      totalPerson: 0, // 實際取得的人員總數
      personList: [], // 實際取得的人員列表

      // 功能列
      showActionBar: false, // 預設不顯示
      choosePersonList: [], // 選取之人員列表

      doSearch: false,

      // 顯示詳細資訊
      isShowDetail: false,
      detailCurrentPage: 0,
      ResumeType: "IDL",
      MatchId: null,
      ResumeId: null,
      Email: null,

      // 檢視歷程
      historyPerson: {},

      // 分享履歷（接收者列表）
      ReceiverIds: [],

      // 轉入職缺（職缺Id）
      matchDemandId: null,

      // 加入黑名單
      blacklistPerson: [], // 人員
      backlistReason: [], // 原因

      //黑名單歷程
      blackHistoryData: [],

      // 檢視歷程
      Name: null,
      UserId: null,

      // API 回應資訊
      messageType: "job",
      successMessage: [], // 成功訊息
      failMessage: [], // 失敗訊息

      interviewee: null,

      // 職缺列表
      openingOptions: [],
      // 員工列表
      supervisorOptions: [],
    };
  },

  methods: {
    // 解除 黑名單
    blacklistRemoval() {
      this.updateLoading(true);
      const person = this.choosePersonList.map((item) => item.ResumeId);
      this.$api.talentPool.removeBlacklist(person).then((response) => {
        if (response.status === 200) {
          this.clearSelectCard();
          this.messageType = "blacklist";
          this.successMessage = response.data.filter((item) => {
            return item.indexOf("成功") !== -1;
          });
          this.failMessage = response.data.filter((item) => {
            return item.indexOf("失敗") !== -1;
          });
          this.$store.commit("OpenResponseDataModal", true);

          this.currentPage = 1;
          this.getTalent();
        }
        this.updateLoading(false);
      });
    },

    // 取得 人才
    getTalent() {
      let params;
      const query = JSON.parse(localStorage.QUERY);
      if (this.originPath === "複合查詢") {
        params = {
          ...query,
          Page: this.currentPage,
          PerPage: 9,
        };
      } else {
        params = {
          Keyword: query,
          Page: this.currentPage,
          PerPage: 9,
        };
      }

      this.updateLoading(true);
      this.$store.commit("ScrollTop", true);

      this.$api.talentPool
        .getTalent({
          ...params,
        })
        .then((response) => {
          if (response.status === 200) {
            this.totalPerson = response.data.Quantity;
            this.personList = response.data.Datas.map((item) => {
              return {
                ...item,
                isChecked: false,
                Education:
                  item.Education === null ? [] : item.Education.split("</div>"),
                WorkExperience:
                  item.WorkExperience === null
                    ? []
                    : item.WorkExperience.split("</div>"),
              };
            });
            this.$store.commit("ScrollTop", false);
          }
          this.doSearch = true;
          this.updateLoading(false);
        });
    },

    // 換頁
    changePage(page) {
      this.currentPage = page;
      this.getTalent();
    },

    // 匯出 人才
    exportTalent() {
      const query = JSON.parse(localStorage.QUERY);
      let data;
      data = this.originPath === "人才查詢" ? { keyword: query } : { ...query };
      this.updateLoading(true);
      this.$api.talentPool.exportTalent(data).then((response) => {
        if (response.status === 200) {
          let fileName = decodeURIComponent(
            decodeURIComponent(
              response.headers["content-disposition"].split(
                "filename*=UTF-8''"
              )[1]
            )
          );
          this.updateLoading(false);
          let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },

    // Action Modal
    openActionModal({ action }) {
      switch (action) {
        case "matchJob":
          this.matchDemandId = null;
          this.$refs.matchDemandId.reset();
          $("#matchJobModal").modal("show");
          break;
        case "shareResume":
          this.ReceiverIds = [];
          this.$refs.ReceiverIds.reset();
          $("#shareResumeModal").modal("show");
          break;
        case "addBacklist":
          this.blacklistPerson = [];
          this.backlistReason = null;
          this.$refs.backlistReason.reset();
          $("#blacklistModal").modal("show");
          break;
      }
    },

    // 轉入職缺 API
    matchJobManagement() {
      const vm = this;
      const api = `${window.endpoints.api}/Recruitment/MatchJobManagement`;

      const data = {
        ManpowerDemandNo: vm.matchDemandId,
        Resumes: vm.choosePersonList.map((item) => {
          return {
            ResumeId: item.ResumeId,
            ResumeType: item.ResumeType,
          };
        }),
      };

      $("#matchJobModal").modal("hide");
      vm.clearSelectCard();

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            this.messageType = "job";
            vm.successMessage = response.data.filter((item) => {
              return item.indexOf("成功") !== -1;
            });
            vm.failMessage = response.data.filter((item) => {
              return item.indexOf("失敗") !== -1;
            });
            this.$store.commit("OpenResponseDataModal", true);
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "轉入職缺失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 分享履歷 API
    shareResume() {
      const vm = this;
      const api = `${window.endpoints.api}/TalentData/ShareResume/Batch`;

      const data = {
        ShareResumes: vm.choosePersonList.map((item) => {
          return { ResumeType: item.ResumeType, Id: item.ResumeId };
        }),
        SenderId: vm.$cookies.get("userId"),
        ReceiverIds: vm.ReceiverIds,
      };
      $("#shareResumeModal").modal("hide");

      vm.clearSelectCard();
      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "已成功分享履歷",
              type: "success",
              duration: 2500,
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 職缺意願
    showJobIntention(person) {
      this.interviewee = person;
      this.$store.commit("OpenJobIntentionModal", true);
    },

    // 顯示黑名單歷程
    showBlackHistory(person) {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);

      vm.$api.talentPool
        .getBlackHistory(person.ResumeId)
        .then((response) => {
          if (response.status === 200) {
            vm.blackHistoryData = response.data;
            $("#blackHistoryModal").modal("show");
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 加入黑名單 API
    addBlacklist() {
      const vm = this;
      const api = `${window.endpoints.api}/TalentData/Blacklist/Batch`;
      const data = vm.choosePersonList.map((item) => {
        return {
          ResumeId: item.ResumeId,
          Reason: vm.backlistReason,
        };
      });

      $("#blacklistModal").modal("hide");

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            this.clearSelectCard();
            this.$store.dispatch("updateLoading", false);
            this.messageType = "blacklist";

            this.successMessage = response.data.filter((item) => {
              return item.indexOf("成功") !== -1;
            });
            this.failMessage = response.data.filter((item) => {
              return item.indexOf("失敗") !== -1;
            });
            this.$store.commit("OpenResponseDataModal", true);

            this.totalPerson = 0;
            this.personList = [];
            this.currentPage = 1;
            this.getTalent();
          }
        })
        .catch((error) => {
          vm.clearSelectCard();
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 聯繫資訊
    showContactInfo(person) {
      this.interviewee = person;
      this.$store.commit("OpenContactInfoModal", true);
    },

    // 檢視歷程
    showProgressRecord(person) {
      this.MatchId = person.Id;
      this.Name = person.Name;
      this.UserId = person.UserId;
      this.Email = person.Email;
      this.$store.commit("OpenCandidateProcessModal", true);
    },

    // 即時更新選取人員之列表
    updatePersonList(choosePerson) {
      let repeatIndex = this.choosePersonList.findIndex(
        (element) => element.ResumeId === choosePerson[0].ResumeId
      );
      if (repeatIndex === -1) {
        this.choosePersonList.push(choosePerson[0]);
      } else {
        this.choosePersonList.splice(repeatIndex, 1);
      }
    },

    // 全選
    selectAllCards() {
      this.personList.forEach((item) => {
        if (!item.isChecked) {
          item.isChecked = true;
        }
      });
      this.choosePersonList = this.personList.filter(
        (item) => item.isChecked === true
      );
    },

    // 清除
    clearSelectCard() {
      this.personList.forEach((item) => {
        item.isChecked = false;
      });
      this.choosePersonList = [];
    },

    // 檢視資訊 Modal
    showDetailModal(person) {
      this.MatchId = person.MatchId;
      this.ResumeId = person.ResumeId;
      this.Email = person.Email;
      this.isShowDetail = true;
    },

    // 導向該職缺頁
    goToJobListPage() {
      const ResumeCard = {
        DemandNo: this.matchDemandId,
      };
      localStorage.setItem("ResumeCard", JSON.stringify(ResumeCard));
      $(".modal-backdrop").remove();
      this.$router.push({
        path: "/manager/opening/resume",
        query: { did: this.matchDemandId }
      });
    },

    async getData() {
      await this.getTalent();
      try {
        const backgroundUser =
          await this.$api.backgroundUser.getBackgroundUser();
        // 取得主管列表
        this.supervisorOptions = backgroundUser.data.map((user) => {
          return {
            Guid: user.UserId,
            Name: user.Name,
            Email: user.Email,
          };
        });
        // 取得 職缺
        const opening = await this.$api.opening.getOpening();
        this.openingOptions = opening.data.map((item) => {
          return {
            ManpowerDemandNo: item.ManpowerDemandNo,
            ManpowerDemandName: item.ManpowerDemandName,
          };
        });
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // 日期格式轉換
    dateFormatter(row, column) {
      if (row[column.property]) {
        return this.dayjs(row[column.property]).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },

    disabled() {
      return this.stopGetNextPage;
    },
  },

  watch: {
    // 選取人員列表
    choosePersonList: function (e) {
      this.showActionBar = e.length > 0;
    },
  },

  created() {
    this.originPath = localStorage.getItem("ORIGIN_PATH");
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.$notify.closeAll();
  },
};
</script>

<style lang="scss" scoped>
.explanation {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  background-color: #df2e2e;
  color: #fff;
  z-index: 3;
  font-weight: bold;
  font-size: 1.2em;
  cursor: pointer;
  vertical-align: middle;
  padding: 0;
}

.resume-tip {
  width: 400px;
  text-align: center;
  font-size: 0.8em;
  padding: 40px;
  margin-left: 15px;
  background-color: #fff;
  border-radius: 10px;
  img {
    max-width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 40px;
  }
}

#matchJobModal {
  /deep/ .el-select-dropdown__wrap .el-scrollbar__wrap {
    width: 780px;
  }
  .modal-content {
    border-radius: 0;
  }
  .modal-header {
    display: block;
    span {
      padding: 10px 0;
      font-size: 1.2em;
      font-weight: lighter;
      letter-spacing: 1px;
      display: block;
      position: relative;
    }
  }
  .modal-body {
    max-height: unset;
    overflow: unset;
  }

  .job-position {
    width: 270px;
    left: -160px;
    bottom: -70px;
    position: relative;
    @media screen and (max-width: 767px) {
      opacity: 0;
    }
  }
}

.select-count {
  position: fixed;
  bottom: 18px;
  right: 30px;

  padding: 15px 10px;
  text-align: center;
  z-index: 11;
  transform: translateY(100%);
  transition: all 0.3s;
  &.showing {
    transform: translateY(0);
    img {
      transform: rotate(0deg);
    }
  }

  i {
    transform: scale(0.8);
    position: relative;
    top: -2px;
  }

  img {
    vertical-align: bottom;
    margin-right: -80px;
    width: 150px;
    position: relative;
    z-index: 2;
    transform: rotate(-93deg);
    transform-origin: right bottom;
    transition: all 0.5s cubic-bezier(0.37, 0.71, 1, 1.23);
  }
  .select-count-inner {
    display: inline-block;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
    padding: 20px;
    padding-left: 50px;
    border-radius: 42px;
    border: 3px solid #ffc727;

    .edit-btn {
      background-color: #5380f7;
      display: inline-block;
      padding: 3px;
      border-radius: 50%;
      box-shadow: 3px 0px 5px rgba(0, 0, 0, 0.3);
      position: relative;
      transition: all 0.3s;
      margin-right: 5px;

      span {
        position: absolute;
        white-space: nowrap;
        background-color: #000;
        color: #fff;
        left: 50%;
        bottom: -30px;
        transform: translateX(-50%);
        padding: 3px 10px;
        border-radius: 10px;
        pointer-events: none;
        opacity: 0;
        font-size: 0.8em;
        transition: all 0.3s;

        &::before {
          content: "";
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 5px 5px 5px;
          border-color: transparent transparent #000 transparent;
          position: absolute;
          left: 50%;
          top: -5px;
          transform: translateX(-50%);
        }
      }

      &:hover {
        transform: scale(1.1);

        span {
          opacity: 1;
        }
      }

      &.ban {
        background-color: #dc5555;
      }
    }

    .clear-btn {
      background-color: #eaeaea;
      text-decoration: none;
      padding: 0px 10px;
      line-height: 33px;
      display: inline-block;
      border-radius: 25px;
      font-size: 0.8em;
      cursor: pointer;
    }
  }
}

#shareResumeModal {
  .modal-content {
    border-radius: 0;
  }
  .modal-header {
    display: block;
    span {
      padding: 6px 0;
      font-size: 1em;
      font-weight: lighter;
      letter-spacing: 1px;
      display: block;
      position: relative;
    }
  }
  .modal-body {
    max-height: unset;
    overflow: unset;
  }
  .job-position {
    width: 270px;
    left: -160px;
    bottom: -70px;
    position: relative;
    @media screen and (max-width: 767px) {
      opacity: 0;
    }
  }
}

/deep/ .el-pagination {
  padding: 0;
  padding-bottom: 8px;
}

#messageModal {
  padding: 0;
  .modal-content {
    padding: 0;
  }

  .modal-header {
    position: relative;
    display: none;
  }
  .modal-body {
    padding: 0;
    .result-info {
      flex: 1;
      min-width: 1px;
      padding: 10px;

      img {
        width: 100px;
        vertical-align: middle;
      }
      .title {
        display: inline-block;
        vertical-align: middle;

        span {
          display: block;
          font-size: 1.3em;
        }
      }
    }

    .result-list {
      padding: 10px;

      .state-btn-wrap {
        display: flex;

        a {
          flex: 1;
          display: inline-block;
          color: #000;
          padding: 10px;
          border-radius: 5px 5px 0 0;
          i {
            margin-right: 10px;
          }
          span {
            font-size: 1.5em;
            font-weight: bold;
            margin: 0 10px;
          }

          &.success {
            background-color: #e4eafa;
          }
          &.failure {
            background-color: #fdd1d1;
          }
        }
      }

      & > img {
        width: 200px;
        display: none;
      }

      .result-person-list {
        background-color: #e4eafa;
        padding: 20px;

        &.failed {
          background-color: #fdd1d1;
        }
        .person {
          display: flex;
          color: #000;
          align-items: center;
          background: #fff;
          margin-bottom: 5px;
          padding: 5px;
          border-radius: 25px;
          &:last-child {
            margin-bottom: 0;
          }

          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 2px solid #000;
            margin-right: 10px;
            background-color: #fff;
          }
        }
      }
    }
  }
}
</style>
